<template>
    <div id="activate-view">
        <div class="activate-content">
            <div class="c-login">
                <div class="login-card">
                    <!-- État : En cours de vérification -->
                    <div v-if="loading" class="activate-state">
                        <div class="activate-icon loading">
                            <div class="spinner-activation"></div>
                        </div>
                        <h2>Vérification en cours...</h2>
                        <p>Veuillez patienter pendant que nous activons votre compte.</p>
                    </div>

                    <!-- État : Activation réussie -->
                    <div v-else-if="success" class="activate-state">
                        <div class="activate-icon success">
                            <i class="fa fa-check-circle"></i>
                        </div>
                        <h2>Compte activé avec succès !</h2>
                        <p class="success-message">Votre adresse e-mail a été vérifiée.</p>
                        <p class="redirect-message">Vous allez être connecté automatiquement...</p>
                    </div>

                    <!-- État : Erreur d'activation -->
                    <div v-else-if="error" class="activate-state">
                        <div class="activate-icon error">
                            <i class="fa fa-times-circle"></i>
                        </div>
                        <h2>Erreur d'activation</h2>
                        <p class="error-message">{{ errorMessage }}</p>
                        <p class="help-text">
                            Le lien d'activation est peut-être expiré ou invalide.
                        </p>
                        <router-link :to="{ name: 'login' }" class="btn-back-login">
                            <i class="fa fa-sign-in" aria-hidden="true"></i>
                            <span>Retour à la connexion</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section Footer -->
        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Découvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits réservés.
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'activate',
    props: ['token'],

    data() {
        return {
            loading: true,
            success: false,
            error: false,
            errorMessage: ''
        };
    },

    methods: {
        ...mapActions({
            activateAccount: 'auth/activate'
        }),

        async performActivation() {
            try {
                this.loading = true;
                await this.activateAccount(this.token);
                
                // Activation réussie
                this.loading = false;
                this.success = true;
                
                // Redirection automatique après 2 secondes
                setTimeout(() => {
                    this.$router.push({ name: 'home' });
                }, 2000);
            } catch (err) {
                // Activation échouée
                this.loading = false;
                this.error = true;
                
                if (err && err.data && err.data.message) {
                    this.errorMessage = err.data.message;
                } else {
                    this.errorMessage = 'Une erreur est survenue lors de l\'activation de votre compte.';
                }
                
                console.error('Erreur activation:', err);
            }
        }
    },

    mounted() {
        if (this.token) {
            this.performActivation();
        } else {
            this.loading = false;
            this.error = true;
            this.errorMessage = 'Token d\'activation manquant.';
        }
    }
};
</script>

<style>
/* Keep only the modern footer on activate page */
.app-container.activate .footer-component {
    display: none !important;
}
</style>

<style scoped>
#activate-view {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.activate-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
}

.c-login {
    width: 100%;
    max-width: 500px;
}

.login-card {
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    padding: 40px 30px;
}

.activate-state {
    text-align: center;
}

.activate-icon {
    font-size: 72px;
    margin-bottom: 25px;
}

.activate-icon.loading {
    display: flex;
    justify-content: center;
}

.spinner-activation {
    width: 72px;
    height: 72px;
    border: 6px solid #f3f3f3;
    border-top: 6px solid #59c362;
    border-radius: 50%;
    animation: spin-activation 1s linear infinite;
}

@keyframes spin-activation {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.activate-icon.success {
    color: #59c362;
}

.activate-icon.error {
    color: #dc3545;
}

.activate-state h2 {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin: 0 0 15px 0;
}

.activate-state p {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin: 0 0 15px 0;
}

.success-message {
    font-size: 17px;
    color: #555 !important;
    font-weight: 500;
}

.redirect-message {
    font-size: 14px;
    color: #888 !important;
    font-style: italic;
}

.error-message {
    font-size: 17px;
    color: #dc3545 !important;
    font-weight: 500;
}

.help-text {
    font-size: 14px;
    color: #888 !important;
    margin-bottom: 25px !important;
}

.btn-back-login {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-top: 15px;
    padding: 14px 35px;
    background: linear-gradient(135deg, #59c362 0%, #48a551 100%);
    color: white;
    text-decoration: none;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(89, 195, 98, 0.2);
}

.btn-back-login:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(89, 195, 98, 0.3);
}

.btn-back-login:active {
    transform: translateY(0);
}

.btn-back-login i {
    font-size: 18px;
}

/* Section Footer */
.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 0;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* Responsive Footer */
@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .login-card {
        padding: 30px 20px;
    }
    
    .activate-icon {
        font-size: 56px;
    }
    
    .spinner-activation {
        width: 56px;
        height: 56px;
    }
    
    .activate-state h2 {
        font-size: 20px;
    }

    .footer-section {
        padding: 2rem 1rem 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .footer-section {
        padding: 1.5rem 1rem;
    }

    .footer-logo {
        width: 35px;
        height: 35px;
    }

    .footer-brand-name {
        font-size: 1.1rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.2rem;
    }

    .footer-column-title {
        font-size: 0.95rem;
    }

    .footer-links a {
        font-size: 0.85rem;
    }

    .social-link {
        width: 40px;
        height: 40px;
    }

    .social-link i {
        font-size: 1.1rem;
    }
}
</style>
